import bProgress from './progress.vue';

export default bProgress;


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/components/progress/progress.js
// module id = 531
// module chunks = 0